/* eslint-disable import/no-cycle */
import {Space} from 'antd';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCircle} from '@fortawesome/free-solid-svg-icons';
import {useTranslation} from 'react-i18next';
import {observer} from 'mobx-react-lite';
import {transformation} from '../../../utils/transformations';
import {datetimeFormat} from '../../../config/moment';
import Table from '../../shared/tables/Table';
import styles from '../qualityIndicator/QualityIndicator.module.scss';
import {useStore} from '../../../hooks/useStore';
import {InspectionTaskValuation} from '../../../models/inspectionTaskResult';

const QualitativeDetails = ({results}) => {
  const {t} = useTranslation();
  const store = useStore();

  const valuationStatusColor = (valuation) =>
    (valuation === InspectionTaskValuation.accepted ? styles.colorGood : styles.colorBad);
  const columns = [
    {
      key: 'date',
      title: t('inspectionTaskResult.model.attributes.createdAt'),
      dataIndex: 'createdAt',
      render: transformation.datetime({format: datetimeFormat}),
    },
    {
      key: 'value',
      title: t('inspectionTaskResult.model.attributes.value'),
      render: (record) => {
        if (record.overruledUserId) {
          return (
            <>
              <Space>
                <FontAwesomeIcon icon={faCircle} style={{color: valuationStatusColor(record.valuation)}}/>
                <s>{record.value}</s>
              </Space>
              <br/>
              <Space>
                <FontAwesomeIcon icon={faCircle} style={{color: valuationStatusColor(record.overruledValuation)}}/>
                {record.overruledValue}
              </Space>
            </>
          );
        }
        return (
          <Space>
            <FontAwesomeIcon icon={faCircle} style={{color: valuationStatusColor(record.valuation)}}/>
            {record.value}
          </Space>
        );
      },
    },
    {
      key: 'user',
      title: t('inspectionTaskResult.model.attributes.createdBy'),
      dataIndex: 'createdBy',
      render: (userId, record) => {
        const value = store.userStore.getById(userId)?.fullName;
        if (record.overruledUserId) {
          const overruledValue = store.userStore.getById(record.overruledUserId)?.fullName;
          return (
            <>
              <s>{value}</s>
              <br/>
              {overruledValue}
            </>
          );
        }
        return value;
      },
    },
    {
      key: 'remark',
      title: t('inspectionTaskResult.model.attributes.remark'),
      dataIndex: 'remark',
      render: (value, record) => {
        if (record.overruledUserId) {
          return (
            <>
              <s>{value}</s>
              <br/>
              <span>{record.overruledRemark}</span>
            </>
          );
        }
        return value;
      },
    },
  ];
  return (
    <>
      <Table striped pagination={false} columns={columns} dataSource={results} rowKey={'id'} style={{width: '100%'}}/>
    </>
  );
};

export default observer(QualitativeDetails);
